import React from 'react';
import ReactDOM from 'react-dom';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import LocalDomain from './Components/localdomain';
import Variables from './Components/variables';
import Pools from './Components/pools';
import Modules from './Components/modules';
import Peatland from './Components/peatland_output_modules';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function ButtonAppBar() {
  const classes = useStyles();
  const [file, setFile] = React.useState("");

  const handleChange = (event) => {
    setFile(event.target.value);
    if(event.target.value==="localdomain") ReactDOM.render(<LocalDomain />, document.getElementById("json"));
    else if(event.target.value==="variables") ReactDOM.render(<Variables />, document.getElementById("json"));
    else if(event.target.value==="pools") ReactDOM.render(<Pools />, document.getElementById("json"));
    else if(event.target.value==="modules") ReactDOM.render(<Modules />, document.getElementById("json"));
    else if(event.target.value==="peatland_output_modules") ReactDOM.render(<Peatland />, document.getElementById("json"));
  };
  
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            JSONTemplates
          </Typography>
          <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-label">Choose File</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={file}
            onChange={handleChange}
          >
            <MenuItem value="localdomain">standard_gcbm_localdomain.json</MenuItem>
            <MenuItem value="variables">standard_gcbm_variables.json</MenuItem>
            <MenuItem value="pools">pools.json</MenuItem>
            <MenuItem value="modules">modules.json</MenuItem>
            <MenuItem value="peatland_output_modules">peatland_output_modules.json</MenuItem>
            {/* <MenuItem value={30}>Thirty</MenuItem> */}
          </Select>
        </FormControl>
        <div id="btn">
          {/* <Button color="inherit">SHOW JSON</Button> */}
        </div>
        </Toolbar>
      </AppBar>
      <div id="json"></div>
    </div>
  );
}
